(function () {
  function initAccordions(root) {
    if (!root) return;
    root.querySelectorAll('[data-lpz-acc-trigger]').forEach(function (btn) {
      if (btn.dataset.lpzAccBound === 'true') return;
      btn.dataset.lpzAccBound = 'true';

      btn.addEventListener('click', function () {
        var panel = btn.parentElement.querySelector('[data-lpz-acc-panel]');
        if (!panel) return;

        var isOpen = btn.classList.contains('is-open');
        btn.classList.toggle('is-open', !isOpen);
        panel.classList.toggle('is-open', !isOpen);
        panel.hidden = isOpen;
        btn.setAttribute('aria-expanded', String(!isOpen));

        var icon = btn.querySelector('.lpz-pd-acc-icon');
        if (icon) icon.textContent = isOpen ? '+' : '−';

        if (btn.hasAttribute('data-lpz-ask-trigger') && !isOpen) {
          var askBtn = document.querySelector('.form-ask__button');
          if (askBtn) askBtn.click();
        }
      });
    });
  }

  function isSizeOption(name) {
    return /size/i.test(name || '');
  }

  function isColorOption(name) {
    return /color|colour/i.test(name || '');
  }

  function colorFromName(name) {
    var map = {
      black: '#111111',
      white: '#ffffff',
      navy: '#1b2a4a',
      blue: '#1b2a4a',
      brown: '#5c4033',
      green: '#ee4076',
      grey: '#888888',
      gray: '#888888',
      red: '#c0392b'
    };
    var key = (name || '').toLowerCase().trim();
    return map[key] || key || '#cccccc';
  }

  function setupSizeOption(field) {
    if (field.dataset.lpzSizeDone === 'true') return;
    field.dataset.lpzSizeDone = 'true';
    field.classList.add('lpz-pd-option-size');

    var labelRow = field.querySelector('.prod__option-label--button');
    var selected = field.querySelector('.selected-value');
    var sizeGuide = field.querySelector('[data-open-sizeguide]');

    var head = document.createElement('div');
    head.className = 'lpz-pd-size-head';

    var labelText = document.createElement('p');
    labelText.className = 'lpz-pd-size-label';
    labelText.innerHTML = 'SIZE — <span class="lpz-pd-size-val"></span>';

    head.appendChild(labelText);

    if (sizeGuide) {
      sizeGuide.classList.remove('hidden');
      sizeGuide.textContent = 'Size Guide';
      head.appendChild(sizeGuide);
    }

    if (labelRow) labelRow.replaceWith(head);

    var valEl = head.querySelector('.lpz-pd-size-val');
    var sync = function () {
      var val = selected ? selected.textContent.trim() : '';
      if (valEl) valEl.textContent = val ? val + ' selected' : '';
    };
    sync();
    if (selected) {
      new MutationObserver(sync).observe(selected, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function setupColorOption(field) {
    if (field.dataset.lpzColorDone === 'true') return;
    field.dataset.lpzColorDone = 'true';
    field.classList.add('lpz-pd-option-color');

    var values = field.querySelectorAll('.variant-picker__option');
    var isSingle = values.length <= 1;
    if (isSingle) {
      field.classList.add('lpz-pd-option-color--single');
    }

    var labelRow = field.querySelector('.prod__option-label--button, .prod__option-label--color');
    if (labelRow) {
      var selected = field.querySelector('.selected-value');
      var head = document.createElement('p');
      head.className = 'lpz-pd-color-label';
      head.innerHTML = 'COLOR — <span class="lpz-pd-color-val"></span>';
      labelRow.replaceWith(head);

      var valEl = head.querySelector('.lpz-pd-color-val');
      var sync = function () {
        var val = selected ? selected.textContent.trim() : '';
        if (!val && values.length === 1) {
          var btn = values[0].querySelector('.sf-po__option-button, .variant-picker__option-button');
          val = btn ? (btn.dataset.colorName || btn.textContent || '').trim() : '';
        }
        if (valEl) valEl.textContent = val ? val + ' selected' : '';
      };
      sync();
      if (selected) {
        new MutationObserver(sync).observe(selected, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }

    field.querySelectorAll('.sf-po__option-button, .variant-picker__option-button').forEach(function (btn) {
      var text = (btn.dataset.colorName || btn.textContent || '').trim();
      if (!text) return;
      btn.textContent = '';
      btn.style.setProperty('--lpz-swatch', colorFromName(text));
      btn.setAttribute('aria-label', text);
      btn.dataset.colorName = text;
    });

    if (isSingle && values.length === 1) {
      values[0].classList.add('active');
    }
  }

  function initVariantOptions(root) {
    if (!root) return;

    root.querySelectorAll('.lpz-pd-options .product-options__option').forEach(function (option) {
      var picker = option.querySelector('[data-option-name]');
      if (!picker) return;
      var name = picker.getAttribute('data-option-name');

      if (isSizeOption(name)) {
        setupSizeOption(option);
      } else if (isColorOption(name)) {
        setupColorOption(option);
      }
    });
  }

  function bindAskLinks(root) {
    if (!root) return;
    root.querySelectorAll('a[href="#ask-question"]').forEach(function (link) {
      if (link.dataset.lpzAskBound === 'true') return;
      link.dataset.lpzAskBound = 'true';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var trigger = document.querySelector('.form-ask__button');
        if (trigger) trigger.click();
      });
    });
  }

  function hasReviewAppContent(node) {
    if (!node) return false;
    if (node.querySelector('.jdgm-prev-badge, .jdgm-star, .loox-rating, .yotpo, .stamped-fa-star, .spr-badge, .spr-starrating, .scm-reviews-rate[data-rate-version2]')) {
      return true;
    }
    var badge = node.querySelector('.shopify-product-reviews-badge');
    if (badge && badge.children.length > 0) return true;
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 3;
  }

  function initShopifyProductReviews() {
    var runSpr = function () {
      if (!window.SPR) return false;
      try {
        if (typeof SPR.initDomEls === 'function') SPR.initDomEls();
        SPR.registerCallbacks('onReady', function () {
          if (typeof SPR.loadBadges === 'function') SPR.loadBadges();
          if (typeof SPR.loadProducts === 'function') SPR.loadProducts();
        });
        if (typeof SPR.loadBadges === 'function') SPR.loadBadges();
        if (typeof SPR.loadProducts === 'function') SPR.loadProducts();
      } catch (error) {}
      return true;
    };

    if (runSpr()) return;

    var script = document.querySelector('script[data-lpz-spr]');
    if (script) {
      script.addEventListener('load', runSpr);
    }

    window.setTimeout(runSpr, 800);
    window.setTimeout(runSpr, 2500);
  }

  function initReviewsSection() {
    document.querySelectorAll('[data-lpz-reviews-section]').forEach(function (section) {
      var content = section.querySelector('[data-lpz-reviews-content]');
      if (!content) return;

      var hasContent = function () {
        if (content.querySelector('.lpz-pd-review-item, .spr-review, .jdgm-rev-widg, .loox-reviews-default, .yotpo-main-widget, .stamped-main-widget-reviews, .scm-reviews-rate')) {
          return true;
        }
        var widget = content.querySelector('#shopify-product-reviews');
        if (widget && widget.children.length > 0) return true;
        var text = (content.textContent || '').replace(/\s+/g, ' ').trim();
        return text.length > 20;
      };

      var sync = function () {
        section.classList.toggle('is-empty', !hasContent());
      };

      sync();
      window.setTimeout(sync, 1500);
      window.setTimeout(sync, 4000);

      if (window.MutationObserver) {
        new MutationObserver(sync).observe(content, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    });
  }

  function initDynamicRating(root) {
    if (!root) return;
    var rating = root.querySelector('[data-lpz-rating]');
    if (!rating || rating.dataset.lpzRatingBound === 'true') return;
    rating.dataset.lpzRatingBound = 'true';

    var appWrap = rating.querySelector('[data-lpz-rating-app]');
    var fallback = rating.querySelector('[data-lpz-rating-fallback]');
    if (!appWrap) return;

    initShopifyProductReviews();

    var syncRating = function (forceFallback) {
      if (hasReviewAppContent(appWrap)) {
        if (fallback) fallback.hidden = true;
        appWrap.hidden = false;
        return;
      }
      if (forceFallback && fallback) {
        fallback.hidden = false;
        appWrap.hidden = true;
      }
    };

    syncRating(false);
    window.setTimeout(function () { syncRating(false); }, 1500);
    window.setTimeout(function () { syncRating(false); }, 3500);
    window.setTimeout(function () { syncRating(true); }, 6000);

    if (window.MutationObserver) {
      new MutationObserver(function () { syncRating(false); }).observe(appWrap, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function initSection(root) {
    initAccordions(root);
    initVariantOptions(root);
    bindAskLinks(root);
    initDynamicRating(root);
    initReviewsSection();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.lpz-product-page').forEach(initSection);
    initShopifyProductReviews();
    initReviewsSection();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.lpz-product-page');
    if (section) initSection(section);
  });

  if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
    window.MinimogEvents.subscribe('ON_VARIANT_CHANGE', function () {
      document.querySelectorAll('.lpz-product-page').forEach(initVariantOptions);
    });
  }
})();
